/**
 * Registrations — admin queue + the public self-signup endpoint.
 *
 * The admin SPA surfaces `registerOrganization` so platform admins can
 * bootstrap orgs for testing without hitting the self-signup flow via curl.
 */
import { apiGet, apiPost } from '../client.js';
import type {
  RegisterOrganizationBody,
  RegisteredOrganization,
  Registration,
} from '../types.js';

export function listRegistrations(): Promise<Registration[]> {
  return apiGet<Registration[]>('/api/v1/admin/registrations');
}

export function approveRegistration(orgId: string): Promise<Registration> {
  return apiPost<Registration>(`/api/v1/admin/registrations/${orgId}/approve`, {});
}

export function rejectRegistration(orgId: string, reason: string): Promise<Registration> {
  return apiPost<Registration>(`/api/v1/admin/registrations/${orgId}/reject`, { reason });
}

/** Public self-signup — creates a pending registration any authed user can submit. */
export function registerOrganization(body: RegisterOrganizationBody): Promise<RegisteredOrganization> {
  return apiPost<RegisteredOrganization>('/api/v1/registration', body);
}
